import { keyframes } from '@mui/system';

// Shimmer animasyonu - kartların üzerinden ışık geçiyor gibi
export const shimmer = keyframes`
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
`;

// Freeze ve thaw animasyonu - buzlanıp çözülme efekti
export const freeze = keyframes`
  0% {
    filter: brightness(1) blur(0px);
    transform: scale(1);
  }
  50% {
    filter: brightness(0.7) blur(2px);
    transform: scale(0.98);
  }
  100% {
    filter: brightness(1) blur(0px);
    transform: scale(1);
  }
`;

// Pulse animasyonu - hafifçe büyüyüp küçülme
export const refreshPulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.02);
    opacity: 0.9;
  }
`;

// Refresh glow animasyonu - kartların etrafında parıltı
export const refreshGlow = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 rgba(99, 102, 241, 0);
  }
  50% {
    box-shadow: 0 0 20px rgba(99, 102, 241, 0.3);
  }
`;

// Kartlar için refresh animasyon stilleri
export const getRefreshCardStyles = (isRefreshing: boolean) => {
  if (!isRefreshing) return {};
  
  return {
    animation: `${freeze} 1.5s ease-in-out`,
    position: 'relative' as const,
    overflow: 'hidden' as const,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent)',
      animation: `${shimmer} 1.5s ease-in-out`,
      pointerEvents: 'none' as const,
      zIndex: 1,
    },
  };
};

// Tablolar için refresh animasyon stilleri
export const getRefreshTableStyles = (isRefreshing: boolean) => {
  if (!isRefreshing) return {};
  
  return {
    animation: `${freeze} 1.5s ease-in-out`,
    position: 'relative' as const,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(99, 102, 241, 0.1), transparent)',
      animation: `${shimmer} 1.5s ease-in-out`,
      pointerEvents: 'none' as const,
      zIndex: 1,
    },
  };
};

// Paper/Container için refresh animasyon stilleri
export const getRefreshPaperStyles = (isRefreshing: boolean) => {
  if (!isRefreshing) return {};
  
  return {
    animation: `${refreshPulse} 1.5s ease-in-out`,
    position: 'relative' as const,
    overflow: 'hidden' as const,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)',
      animation: `${shimmer} 1.5s ease-in-out`,
      pointerEvents: 'none' as const,
    },
  };
};
